/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_get_inspired_through_docs_films: Phrase =locale => {
  const en = `Get Inspired Through Docs & Films`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Mantente inspirado con nuestros Docus & Pelis.`,
  };
  return phrases[locale] || en;
};
            